import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import NavContainer from './NavContainer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import ClipLoader from "react-spinners/ClipLoader";
import styles from './ClozeTest.css';


const PREPARE_INTERVAL_SEC = 3;
const CONFIRM_INTERVAL_SEC = 3;
const CONFIRM_INTERVAL_SEC_FOR_UNEXPECTED = 15;

function shuffle(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}

class ClozeTest extends Component {
  constructor(props) {
    super(props);

    this.state = {
      current: -1,
      confirming: false,
      choice: {},
      answers: [],
      remain: 0,
      finished: false,
      input: '',
    };
    this.currentWordRef = React.createRef();
    this.textInputRef = React.createRef();
  }

  copyState() {
    const state = Object.assign({}, this.state);
    if (state.choice) {
      state.choice = {};
      Object.entries(this.state.choice).forEach(e => {
        state.choice[e[0]] = Object.assign({}, e[1]);
      });
    }
    if (state.answers) {
      state.answers = state.answers.map(a => a);
    }
    return state;
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.textInputRef.current) {
      return;
    }
    this.textInputRef.current.focus();
  }

  start() {
    const state = this.copyState();
    state.current = 0;
    state.confirming = false;
    let remain = PREPARE_INTERVAL_SEC;
    state.remain = remain;
    state.preparing = true;
    state.finished = false;
    state.choice = this.initializeQuestion(state.current);
    this.setState(state);
    if (this.props.onStart) {
      this.props.onStart();
    }
    const self = this;
    function timeout() {
      remain --;
      const state = self.copyState();
      state.remain = remain;
      if (remain == 0) {
        state.preparing = false;
      }
      self.setState(state);
      if (remain > 0) {
        setTimeout(timeout, 1000);
      }
    };
    setTimeout(timeout, 1000);
  }

  async evaluate(choice) {
    if (this.props.evaluate) {
      return await this.props.evaluate(
        this.props.data.rows[this.state.current],
        choice
      );
    }
    const r = {};
    Object.entries(choice).forEach(c => {
      r[c[0]] = {
        judge: c[1].answer == c[1].correct ? 'correct' : 'incorrect',
        semantic_score: c[1].answer == c[1].correct ? 1.0 : 0.0,
        grammar_score: c[1].answer == c[1].correct ? 1.0 : 0.0,
      };
    });
    return r;
  }

  capitalize(target, ref) {
    if (!target || target.length == 0) {
      return target;
    }
    if (target == 'I') {
      return target;
    }
    if (ref.match(/^[A-Z]+$/)) {
      return target.toUpperCase();
    }
    if (ref.match(/^[a-z]+$/)) {
      return target.toLowerCase();
    }
    if (ref.match(/^[A-Z][a-z]*$/)) {
      return target.charAt(0).toUpperCase() + target.substring(1).toLowerCase();
    }
    return target;
  }

  evaluateCurrent() {
    this.setState({
      evalerror: null,
    }, () => {
      this.evaluate(this.state.choice)
        .then(results => {
          const state = this.copyState();
          let remain = CONFIRM_INTERVAL_SEC;
          if (Object.values(state.choice).some(c => c.correct != c.answer)) {
            remain = CONFIRM_INTERVAL_SEC_FOR_UNEXPECTED;
          }
          state.evaluating = false;
          Object.entries(state.choice).forEach(c => {
            c[1].result = results[c[0]];
          });
          state.confirming = true;
          state.remain = remain;
          console.log('Answer', state);
          this.setState(state);
          const self = this;
          function timeout() {
            remain --;
            if (remain > 0) {
              const state = self.copyState();
              state.remain = remain;
              self.setState(state);
              setTimeout(timeout, 1000);
            } else {
              self.confirm(remain);
            }
          };
          setTimeout(timeout, 1000);
        })
        .catch(error => {
          console.error('Evaluation error', error);
          const state = this.copyState();
          state.evalerror = error.toString();
          this.setState(state);
        })
    })
  }

  answer(text) {
    const ctext = text || this.capitalize(
      this.state.input, Object.values(this.state.choice)
        .filter(c => c.active)[0].correct);
    const state = this.copyState();
    state.input = '';
    const active = Object.entries(state.choice).filter(c => c[1].active)[0];
    active[1].active = false;
    active[1].answer = ctext;
    active[1].result = null;
    active[1].answered = Date.now();
    let first = true;
    this.props.data.rows[state.current].forEach((word, index) => {
      if (!word.includes('|')) {
        return;
      }
      if (index <= active[0]) {
        return;
      }
      if (first) {
        first = false;
        state.choice[index].active = true;
        state.choice[index].started = Date.now();
      }
    });
    if (Object.values(state.choice).filter(c => c.active).length > 0) {
      this.setState(state, () => {
        this.currentWordRef.current.scrollIntoView();
        if (this.textInputRef.current) {
          this.textInputRef.current.focus();
        }
      });
      return;
    }
    // Confirming
    state.evaluating = true;
    this.setState(state, () => {
      this.evaluateCurrent()
    });
  }

  confirm(cremain) {
    const state = this.copyState();
    console.log('Confirm', state);
    const answer = this.processAnswer(state.current, state.choice);
    state.answers.push(answer);
    state.remain = cremain;
    state.current ++;
    state.confirming = false;
    state.choice = this.initializeQuestion(state.current);
    state.preparing = state.choice != null;
    state.finished = state.choice == null;
    let remain = PREPARE_INTERVAL_SEC;
    if (state.preparing) {
      state.remain = remain;
    }
    this.setState(state);
    if (state.finished && this.props.onFinish) {
      this.props.onFinish(state.answers);
    }
    if (!state.preparing) {
      return;
    }
    const self = this;
    function timeout() {
      remain --;
      const state = self.copyState();
      state.remain = remain;
      if (remain == 0) {
        state.preparing = false;
      }
      self.setState(state);
      if (remain > 0) {
        setTimeout(timeout, 1000);
      }
    };
    setTimeout(timeout, 1000);
  }

  processAnswer(current, choice) {
    const answer = [];
    this.props.data.rows[current].forEach((word, index) => {
      if (!word.includes('|')) {
        return;
      }
      answer.push(choice[index]);
    });
    return {
      answer: answer,
    };
  }

  initializeQuestion(current) {
    if (this.props.data.rows.length <= current) {
      return null;
    }
    const choice = {};
    let first = true;
    this.props.data.rows[current].forEach((word, index) => {
      if (!word.includes('|')) {
        return;
      }
      const cands = word.split('|');
      const correct = cands[0];
      const candidates = cands.filter(c => c == '*').length > 0 ? null : shuffle(cands);
      const candidate = (candidates || []).length != 2 ? null : candidates[0];
      const c = {
        answer: null,
        candidate,
        active: false,
        correct: correct,
        candidates,
        result: null,
      };
      if (first) {
        first = false;
        c.active = true;
        c.started = Date.now();
      }
      choice[index] = c;
    });
    return choice;
  }

  inputChange(ev) {
    const state = this.copyState();
    state.input = ev.target.value.trim();
    this.setState(state);
  }

  inputKeyPress(ev) {
    if (ev.key == 'Enter') {
      this.answer();
    }
  }

  answerCorrect(correct) {
    const actives = Object.values(this.state.choice || {}).filter(c => c.active);
    this.answer(actives[0].candidates[correct ? 0 : 1]);
  }

  render() {
    const actives = Object.values(this.state.choice || {}).filter(c => c.active);
    return (
      <div className={styles.ClozeTest}>
        {this.state.current < 0 ?
          <div className={styles.Greeting}>
            <Button
              data-test-cloze-test-start
              disabled={this.props.ready === undefined ? false : !this.props.ready}
              onClick={e => this.start()}
              variant='primary'>
              Cloze Testをはじめる
            </Button>
          </div> :
          (this.state.finished ?
            <div className={styles.Finished}>
              終わりです！
              <div className={styles.Result}>
                {(this.state.answers || []).map(a => a.answer.length).reduce((a, c) => a + c, 0)}
                問中 {(this.state.answers || []).map(a => a.answer.filter(answer => answer.result.judge == 'correct').length).reduce((a, c) => a + c, 0)}
                問正解です！
              </div>
            </div> : <div>
            <div className={styles.StatementPanel}>
              <p className={styles.Statement}>
                {this.props.data.rows[this.state.current].map((word, index) => (
                  word.includes('|') ?
                    <span class={styles.WordInput}>
                      <span
                        ref={this.state.choice[index] && this.state.choice[index].active ? this.currentWordRef : null}
                        className={`${styles.Word} ${styles.Question} ${this.state.preparing == false && this.state.choice[index] && this.state.choice[index].active ?
                          styles.ActiveQuestion : ''} ${this.state.confirming && this.state.choice[index] && this.state.choice[index].result && this.state.choice[index].result.judge == 'correct' ?
                            styles.Correct : ''} ${this.state.confirming && this.state.choice[index] && this.state.choice[index].result && this.state.choice[index].result.judge == 'incorrect' ?
                              styles.Incorrect : ''} ${this.state.evaluating && this.state.choice[index] ? styles.EvaluatingWord : ''}`}>
                        {this.state.preparing || this.state.choice[index] === undefined || (this.state.choice[index].answer === null && !(this.state.choice[index].candidate !== null && this.state.choice[index].active)) ?
                          '\u00A0'.repeat(Math.max(...word.split('|').map(w => w.length)) * 2) :
                          (this.state.choice[index].answer !== null ? this.state.choice[index].answer : this.state.choice[index].candidate)}
                      </span>
                      {this.state.confirming && this.state.choice[index] && this.state.choice[index].result && this.state.choice[index].correct !== this.state.choice[index].answer && <span className={styles.CorrectTip}>
                        <FontAwesomeIcon icon={faCheck} />
                        {this.state.choice[index].correct}
                      </span>}
                    </span> : (index > 0 ? ` ${word}` : word)
                ))}
              </p>
            </div>
            <NavContainer>
              <div className={styles.InputPanel}>
                {this.state.evalerror && <div className={styles.EvalError}>
                  回答評価時にエラーが発生しました。申し訳ありませんがネットワーク環境を確認して評価を再実行してください:
                  <div>
                    {this.state.evalerror}
                  </div>
                  <Button
                    data-test-cloze-retry-evaluate
                    onClick={e => this.evaluateCurrent()}
                    variant='danger'>
                    評価を再実行
                  </Button>
                </div>}
                {(this.state.evaluating && !this.state.evalerror) && <div className={styles.Evaluating}>
                  <ClipLoader />
                  <div>回答を評価中です...</div>
                </div>}
                {this.state.preparing ?
                  <div className={styles.QuestionPrecheck}>
                    上の空欄に入る単語を想像してみましょう！
                    <div className={styles.RemainTime}>問題まであと {this.state.remain} 秒</div>
                  </div> :
                  (this.state.confirming ?
                    <div className={styles.QuestionResult}>
                      {Object.values(this.state.choice).length} 問中 {Object.values(this.state.choice).filter(c => c.result.judge == 'correct').length} 問 正解しました！
                      <div className={styles.RemainTime}>次の画面まであと {this.state.remain} 秒</div>
                    </div> : (actives.length > 0 ?
                      <div className={styles.AnswerPanel}>
                        {actives[0].candidates == null ?
                          <div>
                            <div className={styles.AnswerDescription}>空欄にはいる単語を入力！</div>
                            <Form.Control
                              data-test-cloze-free-input
                              placeholder='空欄にはいる単語'
                              inputMode='url'
                              ref={this.textInputRef}
                              value={this.state.input}
                              ref={c => (this._input = c)}
                              onChange={ev => this.inputChange(ev)}
                              onKeyPress={ev => this.inputKeyPress(ev)} />
                            <Button
                              data-test-cloze-send-answer
                              onClick={e => this.answer()}
                              disabled={this.state.input == ''}
                              variant='primary'>
                              確定
                            </Button>
                          </div> :
                          (actives[0].candidate !== null ?
                            <div>
                              <div className={styles.AnswerDescription}>この単語は正しい？</div>
                              <Button
                                data-test-cloze-send-correct
                                onClick={e => this.answerCorrect(true)}
                                variant='success'>
                                正しい
                              </Button>
                              <Button
                                data-test-cloze-send-incorrect
                                onClick={e => this.answerCorrect(false)}
                                variant='danger'>
                                間違い
                              </Button>
                            </div> :
                            <div>
                              <div className={styles.AnswerDescription}>空欄にはいる単語をタップ！</div>
                              {actives[0].candidates.map(cand =>
                                <Button
                                  data-test-cloze-test-answer
                                  onClick={e => this.answer(cand)}
                                  variant='light'>
                                  {cand}
                                </Button>)}
                          </div>)}
                      </div> : ''))}
              </div>
            </NavContainer>
          </div>)}
      </div>
    );
  }
}

export default ClozeTest;
